/**
 * <s-gallery-arrows>: prev/next buttons that scroll the nearest [data-product-gallery]
 * one slide at a time, disable themselves at either end, and keep the "1 / 9" counter in sync.
 */
class SGalleryArrows extends HTMLElement {
  connectedCallback() {
    this.gallery = this.parentElement?.querySelector('[data-product-gallery]');
    this.prev = this.querySelector('[data-gallery-prev]');
    this.next = this.querySelector('[data-gallery-next]');
    this.counter = this.parentElement?.querySelector('[data-gallery-counter]');
    if (!this.gallery || !this.prev || !this.next) return;

    this.onPrev = () => this.step(-1);
    this.onNext = () => this.step(1);
    this.onScroll = () => this.update();
    this.prev.addEventListener('click', this.onPrev);
    this.next.addEventListener('click', this.onNext);
    this.gallery.addEventListener('scroll', this.onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    this.prev?.removeEventListener('click', this.onPrev);
    this.next?.removeEventListener('click', this.onNext);
    this.gallery?.removeEventListener('scroll', this.onScroll);
  }

  step(direction) {
    const rtl = getComputedStyle(this.gallery).direction === 'rtl';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.gallery.scrollBy({
      left: this.gallery.clientWidth * direction * (rtl ? -1 : 1),
      behavior: reduce ? 'auto' : 'smooth',
    });
  }

  update() {
    const max = this.gallery.scrollWidth - this.gallery.clientWidth;
    const position = Math.abs(this.gallery.scrollLeft);
    this.prev.disabled = position <= 1;
    this.next.disabled = position >= max - 1;
    if (this.counter) {
      const total = this.gallery.children.length;
      const current = Math.min(total, Math.round(position / this.gallery.clientWidth) + 1);
      this.counter.textContent = current + ' / ' + total;
    }
  }
}

if (!customElements.get('s-gallery-arrows')) customElements.define('s-gallery-arrows', SGalleryArrows);
